import $ from 'jquery';
import TweenMax from 'gsap/TweenMax';
import AbstractPage from './AbstractPage';
import {
    getDatasWithOption
} from '../util/service';

class Coupon extends AbstractPage {
    constructor(options) {
        super(options);

        const _ = this;

        // _.option
        // _.model
        // _.$wrap

        _._$contents = $('.section-contents', _.$wrap);
        _._$title = $('h2', _._$contents);
        _._$eventWrap = $('.event-img-wrap', _._$contents);

        _.NOT_PERMITTED_SELF_TARGET = 'NOT_PERMITTED_SELF_TARGET';
        _.NOSELECT_MEMBER = '양도 받을 혈맹원을 선택해주세요';
        _.CONFIRM_GIVE_COUPON = '양도 신청 후 신청 결과를 변경할 수 없습니다. 신청 하시겠습니까?';
        // _.SUCESS_GIVE_COUPON = '신청이 완료되었습니다';
        _.FAIL_GIVE_COUPON = '잠시후 다시 시도해 주세요';
        _.FAIL_NOT_PERMITTED_SELF_TARGET = '본인에게 양도 신청을 할 수 없습니다.';

        _.BANNED_ACCOUNT ='security.BANNED_ACCOUNT'
        _.FAIL_BANNED_ACCOUNT = '제재 계정은 참여할 수 없습니다.'
    }

    init(obj = null) {
        super.init(obj);

        const _ = this;

        _.$layerTJCouponRequestBtn = $('#layerTJCouponRequestBtn');
        _.$layerGuildMemberSelect = $('#layerGuildMemberSelect');
        _.$layerTJCouponFinish = $('#layerTJCouponFinish');
        _.$layerTJCouponRequest = $('#layerTJCouponRequest');

        _._setBtn();
        _._reset();

        return _;
    }

    _setBtn(){
        const _ = this;

        _.$layerTJCouponRequestBtn.on('click', ()=>{ _._onclickLayerTJCouponRequestBtn() })
    }
    
    _onclickLayerTJCouponRequestBtn(){
        const _ = this;

        // ajax
        let targetCharacterId = _.$layerGuildMemberSelect.val();
        console.log(targetCharacterId);

        if(targetCharacterId === 'default'){
            alert(_.NOSELECT_MEMBER)
            return false;
        }

        if(!(confirm(_.CONFIRM_GIVE_COUPON))){
            return false;
        }
        
        getDatasWithOption({
            type: 'POST',
            dataType: 'json',
            url: '/event/p20191107/save.json',
            data: {
                targetCharacterId
            }
        },
        (data, textStatus, jqXHR) => {
            console.log(
                'success data, textStatus, jqXHR :',
                data,
                textStatus,
                jqXHR
            );

            // alert(_.SUCESS_GIVE_COUPON);
            _.$layerTJCouponRequest.hide();
            _.$layerTJCouponFinish.show();
            
        },
        (jqXHR, textStatus, errorThrown) => {
            console.log(
                'fail jqXHR, textStatus, errorThrown :',
                jqXHR,
                textStatus,
                errorThrown
            );

            console.log(jqXHR.responseJSON.result)
            if(jqXHR.responseJSON.result.errorCode.indexOf(_.NOT_PERMITTED_SELF_TARGET)>=0){
                alert(_.FAIL_NOT_PERMITTED_SELF_TARGET)
            }else if(jqXHR.responseJSON.result.errorCode.indexOf(_.BANNED_ACCOUNT)>=0){
                alert(_.FAIL_BANNED_ACCOUNT)
            }else{
                alert(_.FAIL_GIVE_COUPON)
            }
            
        })
    }




    _startAnimation() {
        const _ = this;

        // if (!_.isAnimated) {
        TweenMax.killTweensOf(_._$contents);
        TweenMax.killTweensOf(_._$title);
        TweenMax.killTweensOf(_._$eventWrap);

        TweenMax.fromTo(
            _._$contents,
            0.8, {
                autoAlpha: 0
            }, {
                scale: 1,
                autoAlpha: 1,
                ease: Expo.easeInOut
            }
        );
        TweenMax.fromTo(
            _._$title,
            1.5, {
                autoAlpha: 0
            }, {
                scale: 1,
                autoAlpha: 1,
                ease: Cubic.easeInOut
            }
        );
        TweenMax.fromTo(
            _._$eventWrap,
            1.2, {
                autoAlpha: 0
            }, {
                delay: 0.65,
                scale: 1,
                autoAlpha: 1,
                ease: Cubic.easeOut
            }
        );

        // }
        // _.isAnimated = true;

        return _;
    }

    _reset() {
        const _ = this;

        // if (_.isAnimated) return;

        TweenMax.killTweensOf(_._$contents);
        TweenMax.killTweensOf(_._$title);
        TweenMax.killTweensOf(_._$eventWrap);

        TweenMax.set(_._$contents, {
            autoAlpha: 0
        });
        TweenMax.set(_._$title, {
            autoAlpha: 0
        });
        TweenMax.set(_._$eventWrap, {
            autoAlpha: 0
        });

        return _;
    }

    enter(obj = null) {
        const _ = this;

        _._startAnimation();

        return _;
    }

    exit(obj = null) {
        const _ = this;

        _._reset();

        return _;
    }

    resize(evt = null) {
        const _ = this;

        return _;
    }

    destroy(obj = null) {
        super.destroy(obj);

        const _ = this;

        return _;
    }
}

export default Coupon;